// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3173":"24ffd58b","4164":"8ea69041","4378":"b80215da","5403":"1f657adb","9444":"9c26201d"}[chunkId] + ".chunk.css";
};